// src/core/api/hooks/safety-event/useCreateNewSafetyEvent.ts

import { useMutation } from '@tanstack/react-query';

import { FlightEventFlightDetailsLookup, SafetyEventClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const safetyEventClient = new SafetyEventClient(apiBaseUrl);

function useCreateNewSafetyEvent() {
  return useMutation({
    mutationKey: [queryKeys.SafetyEvent.CreateNew],
    mutationFn: (lookup: FlightEventFlightDetailsLookup) => safetyEventClient.createNew(lookup),
  });
}

export default useCreateNewSafetyEvent;
